import { render, staticRenderFns } from "./CreateEnvironment.vue?vue&type=template&id=32852cee&"
import script from "./CreateEnvironment.vue?vue&type=script&lang=js&"
export * from "./CreateEnvironment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32852cee')) {
      api.createRecord('32852cee', component.options)
    } else {
      api.reload('32852cee', component.options)
    }
    module.hot.accept("./CreateEnvironment.vue?vue&type=template&id=32852cee&", function () {
      api.rerender('32852cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Staging/CreateEnvironment.vue"
export default component.exports